import createAxiosInstance from "../util/axiosInstance";

const api = createAxiosInstance('/ingresos');

const fetchDetallesByIngreso = (ingresoId) => api.get(`/${ingresoId}/detalles`);
const createDetalle = (data) => api.post(`/${data.nrorec}/detalles`, data);
const updateDetalle = (id, data) => api.put(`/ingreso-detalles/${id}`, data);
const deleteDetalle = (id) => api.delete(`/ingreso-detalles/${id}`);

export default {
  fetchDetallesByIngreso,
  createDetalle,
  updateDetalle,
  deleteDetalle,
};